import { useState, useCallback, memo, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import CustomDrawerPanel from "layouts/Flow Designer/components/CustomDrawerPanel";
import ExecutionReportTabs from "./components/ExecutionReportTabs";
import SoftBox from "components/SoftBox";
import ExecutionTimelineLogs from "./components/ExecutionTimelineLogs";
import ExecutionReportPanelHeaderActions from "./components/ExecutionReportPanelHeaderActions";
import { clearNodesHighlight } from "layouts/Flow Designer/helpers/common";
import { Highlighter } from "./components/Highlighter";
import { clearSelectedLogNodeId } from "redux/actions/flowDesigner/flowExecutionActionCreator";
import { useReactFlow } from "reactflow";

const ExecutionPanelBox = styled(Box)(() => ({
  bgcolor: "background.paper",
  width: "100%",
  height: "100%",
  display: "flex !important",
  flexDirection: "column !important",
  position: "relative !important",
  flexGrow: 1
}));

const ExecutionReportPanel = ({ node }) => {
  const [tabValue, setTabValue] = useState(0);
  const timelineContainerRef = useRef(null);
  const dispatch = useDispatch();
  const { setNodes } = useReactFlow();

  const handleChange = useCallback((event, newValue) => {
    setTabValue(newValue);
  }, []);

  useEffect(() => {
    const visibilityEvent = ({ visible }) => {
      if (!visible) {
        clearNodesHighlight();
        setNodes((prev) => prev.map((n) => ({ ...n, selected: false })));
      }
    };

    node.setEventListener("visibility", visibilityEvent);

    return () => {
      clearNodesHighlight();
      dispatch(clearSelectedLogNodeId());
    };
  }, []);

  return (
    <CustomDrawerPanel
      styles={{ padding: 0 }}
      open={true}
      className={`no-translate execution-panel-drawer`}
      isExecutionReportPanel={true}
    >
      <ExecutionPanelBox className="execution-panel">
        <Highlighter />
        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            paddingLeft: 2
          }}
          className="execution-panel-header"
        >
          {tabValue === 0 && <ExecutionReportPanelHeaderActions />}
          <ExecutionReportTabs tabValue={tabValue} handleChange={handleChange} />
        </SoftBox>

        <SoftBox ref={timelineContainerRef} sx={{ flexGrow: 1, overflowY: "hidden" }}>
          <ExecutionTimelineLogs tabValue={tabValue} />
        </SoftBox>
      </ExecutionPanelBox>
    </CustomDrawerPanel>
  );
};

export default memo(ExecutionReportPanel);
